import { color } from 'console-log-colors'
import { crossPlatformRoutes } from '../utils/cross-platform'
import type { CrossPlatformRedirectRoutes } from '@/models/cross-platform'

// This middleware will be used temporary, until we rewrite a full FEC to FEC2.0
// This enables us to force requests to exit Nuxt router and go to the gateway
// Gateway will decide what should be served to the user
export default defineNuxtRouteMiddleware(async (to) => {
  onShowLogs(() => console.info(color.magentaBright('[GLOBAL][01] routing\n'), to.path))

  const { crossPlatformRedirect } = useRedirect()
  const { isDev } = useEnvs()

  // TODO: do we still need this?
  if (isClient) {
    if (!isDev.value && crossPlatformRoutes.includes(to.name)) {
      await new Promise((resolve) => {
        crossPlatformRedirect(to.name as CrossPlatformRedirectRoutes)
        setTimeout(() => {
          resolve(null)
        }, 1000)
      })
    }
  }
})
